export const isDateValid = date => {
  if (Object.prototype.toString.call(date) === '[object Date]') {
    return isNaN(date.getTime()) === false
  }
  return false
}
